import {
  CreditSummaryEntity,
  PaginatedResponse,
  ListParams,
} from "../entities/CreditSummaryEntity";
import { CreditsRepository } from "../repositories/CreditsRepository";

export class GetCustomerOutstandingInvoicesUseCase {
  constructor(private repository: CreditsRepository) {}

  async execute(
    params: ListParams
  ): Promise<PaginatedResponse<CreditSummaryEntity>> {
    return await this.repository.getCustomerOutstandingInvoices(params);
  }
}
